
import React from 'react'
import { Link } from 'react-router-dom'

class NotFound extends React.Component {

    render = () => {
        return (
            <React.Fragment>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height:"80vh"}}>
                  <p><span role="img" aria-label="Frowining Face">😞 I'm sorry Dave, I'm afraid I can't do that.&nbsp;&nbsp;<Link to="/">sweaverD.com</Link></span></p>
                </div>
                
            </React.Fragment>
        )
    }

}
export default NotFound